<template>
  <div>
    <HeaderTop page="home" :isBackgroundShow="isBackgroundShow" :homeTitle="chineseTitle"></HeaderTop>
    <div class="content" @scroll="handleScroll">
      <div class="banner">
        <img :src="bannerImgUrl" alt="">
        <div class="menuTitle">
          <div class="english" :style="{'background-image': 'url('+bannerImgUrl+')'}">{{ englishTitle }}</div>
<!--          <div class="english">{{ englishTitle }}</div>-->
          <div class="chinese"> {{ chineseTitle.length > 10 ? chineseTitle.substr(0, 10) + '...' : chineseTitle }}</div>
        </div>
        <div class="tab" v-if="secondMenuList.length >0 && pageWidth >1280">
          <div class="tab_menu">
            <div v-for="(item, index) in secondMenuList" :key="index"
                 :class="[currentId == item.id ? 'tabItemAct':'','tabItem'].join(' ')" @click="toUp(item)">
              <span v-if="item.type != 1">{{
                  item.name.length > 10 ? item.name.substr(0, 10) + '...' : item.name
                }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="connectus1" v-html="infoHtml">
      </div>
    </div>
    <float-element :showTop="showTop"></float-element>
    <Bottom></Bottom>
  </div>
</template>

<script>
import HeaderTop from "@/components/headerTop"
import Bottom from "@/components/bottom"
import Pagination from '@/components/pagination';
import FloatElement from "@/components/floatElement";

export default {
  name: "imglist",
  components: {
    HeaderTop,
    Bottom,
    Pagination,
    FloatElement
  },
  data() {
    return {
      bannerImgUrl: '',
      pageWidth: 0,
      englishTitle: '',
      chineseTitle: '',
      currentId: '',
      grade: '',
      parentid: '',
      secondMenuList: [],
      infoHtml: '',
      queryParams: {
        pageSize: 5,
        pageNum: 1
      },
      isBackgroundShow: true,
      showTop: false
    }
  },

  created() {
    // if (window.screen.width < '1400'){
    //   document.write('<body style="zoom: 80%">');
    // }
    this.currentId = this.$route.query.id
    this.grade = this.$route.query.grade
    this.parentid = this.$route.query.parentid
    this.getBannerImg() // 获取banner图
    this.getSecondMenuList()
    this.getListData()
  },
  destroyed() {

  },
  watch: {
    currentId(newv) {
      if(newv){
        this.infoHtml = ''
        this.getListData()
      }
    }
  },
  mounted() {
    this.pageWidth = document.documentElement.clientWidth
    window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听器
  },
  methods: {
    handleScroll(event) {
      const scrollTop = window.scrollY; // 获取滚动条相对于文档顶部的距离
      // 产品中心
      if (scrollTop >= 10) {
        // this.isBackgroundShow = true
        this.showTop = true
      } else {
        // this.isBackgroundShow = false
        this.showTop = false
      }
    },
    // 点击二级
    toUp(menu) {
      this.currentId = menu.id
      this.grade = menu.grade
      this.parentid = menu.parentid
      this.getSecondMenuList()
      this.getListData()
      // if (menu.name == '公司介绍') {
      //
      // }
      // if (menu.name == '人力资源') {
      //   this.$router.push({
      //     path: '/humanResource',
      //     query: {
      //       parentid: menu.parentid, id: menu.id, grade: menu.grade, picpath: menu.picpath
      //     }
      //   })
      // }
      // if (menu.name == '联系我们') {
      //   this.$router.push({
      //     path: '/aboutUs',
      //     query: {
      //       parentid: menu.parentid, id: menu.id, grade: menu.grade, picpath: menu.picpath
      //     }
      //   })
      // }
    },
    // 获取列表
    getListData() {
      var params = {}
      if (this.grade == '2') {
        params = {
          secondlevelid: this.currentId,
          pagesize: this.queryParams.pageSize,
          pageindex: this.queryParams.pageNum
        }
      } else {
        params = {
          firstlevelid: this.currentId,
          pagesize: this.queryParams.pageSize,
          pageindex: this.queryParams.pageNum
        }
      }
      this.$API.InterfaceConfigurationPage._getArticleList({
        params
      }).then(res => {
        if (res.success) {
          var n = 0
          if (res.data.length > 0) {
            res.data.forEach((otm, index) => {
              if (otm.type != 1 && n == 0) {
                this.getDetail(otm.id)
                n++
              }
            })
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 获取内容详情
    getDetail(id) {
      this.$API.InterfaceConfigurationPage._getArticleDetail({
        params: {
          id: id
        }
      }).then(res => {
        if (res.success) {
          this.infoHtml = res.data.content
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 获取banner图
    getBannerImg() {
      this.$API.InterfaceConfigurationPage._getMenuList({
        params: {
          grade: 1
        }
      }).then(res => {
        if (res.success) {
          if (res.data == '[]') {
            this.bannerImgUrl = ''
          } else {
            res.data.forEach(item => {
              if (item.id == this.$route.query.parentid) {
                this.bannerImgUrl = item.picpath
              }
            })
          }
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },

    // 获取菜单列表
    getSecondMenuList() {
      var params = {}
      if (this.grade == 1) {
        params = {
          grade: 1
        }
      } else if (this.grade == 2) {
        params = {
          grade: 2,
          firstlevelid: this.parentid
        }
      }
      this.$API.InterfaceConfigurationPage._getMenuList({
        params: params
      }).then(res => {
        if (res.success) {
          this.secondMenuList = res.data.filter(item => item.type != 1)
          this.secondMenuList.forEach(item => {
            if (item.id == this.currentId) {
              this.englishTitle = item.en_name
              this.chineseTitle = item.name
            }
          })
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
  }
}

</script>
<style>
@media screen and (max-width: 1280px) {
  .connectus1 {
    img {
      width: 100%;
      margin: 20px auto;
    }

    span {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 24px;
      text-size-adjust: none;
      color: #333333;
      text-align: left;
    }

    p {
      line-height: 28px;
      text-align: left;
      margin: 10px 0;
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 24px;
      text-size-adjust: none;
      color: #333333;
    }
  }
}

</style>

<style scoped lang="less">

//移动端
.content {
  width: 100%;
  padding-bottom: 300px;

  .banner {
    width: 100%;
    position: relative;
    height: 400px;

    .menuTitle {
      position: absolute;
      top: 153px;
      text-align: left;
      padding-left: 30px;

      .english {
        font-family: D-DINExp-Bold;
        font-weight: bold;
        font-size: 50px;
        text-size-adjust: none;
        color: rgba(255, 255, 255, 0.2);
        position: relative;
        z-index: 99;
        background-repeat: no-repeat;
        background-clip: text;
        -webkit-background-clip: text;
      }

      .chinese {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 42px;
        text-size-adjust: none;
        color: #FFFFFF;
        position: relative;
        z-index: 100;
        margin-top: -50px;
      }
    }

    img {
      width: 100%;
      height: 400px;
    }

    .tab {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40px;
      display: flex;
      background: rgba(80, 118, 175, 0.8);

      .tabItem {
        width: 33.33%;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        color: #ccc;
        cursor: pointer;
      }

      .tabItemAct {
        color: #fff;
      }
    }
  }

  .connectus1 {
    width: 100%;
    padding: 30px;
    min-height: 100px;

    p {
      line-height: 28px;
      text-align: left;
      font-size: 16px;
      text-size-adjust: none;
      margin: 10px 0;
      text-indent: 4ch;
    }

    img {
      width: 96%;
    }
  }
}

//PC端
@media screen and (min-width: 1280px) {
  .content {
    width: 100%;
    padding-bottom: 0px;
    margin-top: 100px;

    .banner {
      width: 100%;
      height: 500px;
      position: relative;

      .menuTitle {
        width: 1400px;
        margin: 0 auto;
        margin-top: -388px;
        padding: 0;
        position: static;

        .english {
          font-family: D-DINExp-Bold;
          font-weight: bold;
          font-size: 65px;
          color: rgba(255, 255, 255, 0.2);
          position: relative;
          z-index: 99;
          background-repeat: no-repeat;
          background-clip: text;
          -webkit-background-clip: text;
        }

        .chinese {
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 54px;
          color: #FFFFFF;
          position: relative;
          z-index: 100;
          margin-top: -55px;
        }
      }

      img {
        width: 100%;
        height: 100%;
      }

      .tab {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 60px;
        background: rgba(80, 118, 175, 0.8);

        .tab_menu {
          width: 1400px;
          display: flex;
          justify-content: space-between;
          margin: 0 auto;
        }

        .tab_menu:first-child {
          text-align: left;
        }

        .tab_menu:last-child {
          text-align: right;
        }

        .tabItem {
          text-align: center;
          line-height: 60px;
          font-size: 24px;
          color: rgba(255, 255, 255, 0.8);
          cursor: pointer;
          width: auto;
        }

        .tabItemAct {
          color: #fff;
          font-size: 24px;
          font-weight: bold;
        }
      }
    }

    .connectus1 {
      width: 1400px;
      margin: 30px auto;
      padding: 0;
      min-height: 400px;
      p {
        line-height: 28px;
        text-align: left;
        font-size: 16px;
        margin: 10px 0;
        text-indent: 4ch;
      }

      img {
        width: 800px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/companyIntro.vue